import { CONTROL_TOOLTIPS } from '@src/containers/Blotters/tooltips';
import { FormControlSizes, Toggle } from '@talos/kyoko';
import { MobileCompactCardsToggle } from '../MobileCompactCardsToggle';
import { MobileShowAllDecimalsToggle } from '../MobileShowAllDecimalsToggle';

interface MobileCreditSettingsTogglesProps {
  onShowZeroBalancesToggle: (checked: boolean) => void;
  showZeroBalances: boolean;
}

export function MobileCreditSettingsToggles({
  onShowZeroBalancesToggle,
  showZeroBalances,
}: MobileCreditSettingsTogglesProps) {
  return (
    <>
      <MobileCompactCardsToggle type="Credit" />
      <Toggle
        label="Show Zero Balances"
        size={FormControlSizes.Default}
        tooltip={CONTROL_TOOLTIPS.showZeroBalances}
        checked={showZeroBalances}
        onChange={onShowZeroBalancesToggle}
        fullWidth
      />
      <MobileShowAllDecimalsToggle />
    </>
  );
}
